<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="29"
  >
    <path
      fill="#FFF"
      fill-rule="nonzero"
      d="M15 2v1H2a1 1 0 0 0-.993.883L1 4v23a1 1 0 0 0 .883.993L2 28h23a1 1 0 0 0 .993-.883L26 27V14h1v13a2 2 0 0 1-1.85 1.995L25 29H2a2 2 0 0 1-1.995-1.85L0 27V4a2 2 0 0 1 1.85-1.995L2 2zM25.245.585l3.17 3.17c.78.78.78 2.045 0 2.826L13.996 21H8v-5.996L22.418.585c.781-.78 2.047-.78 2.827 0m-2.026.624-.094.083L9 15.418v4.583h4.581L27.708 5.874a1 1 0 0 0 .083-1.319l-.083-.094-3.17-3.17a1 1 0 0 0-1.319-.082"
    />
  </svg>
</template>
